import React, { Component } from 'react';
import { connect } from 'react-redux';

import { update_calendar_data } from '../../../../actions/update_data';

import CalendarItem from './CalendarItem';

import './style.css';

/**
 * Функция сортировки даты.
 * @param {Element} a проверяющий элемент
 * @param {Element} b проверяемый элемент
 * 
 * @example
 * let arr = [
 *  {
 *      year: '2019',
 *      data: [...]
 *  },
 *  {
 *      year: '2018',
 *      data: [...]
 *  }
 * ]
 * arr.sort(compareDate); //return [
 * //{
 * //     year: '2018',
 * //     data: [...]
 * // },
 * // {
 * //     year: '2019',
 * //     data: [...]
 * // }
 * //] 
 */
function compareDate(a, b) {
    if (a.year !== undefined && b.year !== undefined) {
        if (+a.year > +b.year) return 1;
        else return -1;
    } else if (a.month !== undefined && b.month !== undefined) {
        if (+a.month > +b.month) return 1;
        else return -1;
    } else if (a.day !== undefined && b.day !== undefined) {
        if (+a.day > +b.day) return 1;
        else return -1;
    }
}

const data = {
    faq_headers: [
        {
            name: 'Чем круг отличается от ручной лепки?',
            data: 'Чем круг отличается от ручной лепки?'
        },
        {
            name: 'Сколько человек в группах по ручной лепке?',
            data: 'Сколько человек в группах по ручной лепке?'
        },
        {
            name: 'Сколько максимально человек вмещает студия?',
            data: 'Сколько максимально человек вмещает студия?'
        },
        {
            name: 'Сколько времени длятся МК',
            data: 'Сколько времени длятся МК'
        },
        {
            name: 'Можно ли самим покрасить свои работы?',
            data: 'Можно ли самим покрасить свои работы?'
        },
        {
            name: 'Через сколько можно забрать готовые работы после мк?',
            data: 'Через сколько можно забрать готовые работы после мк?'
        },
        {
            name: 'Можно ли на гончарный круг и ручную лепку с детьми?',
            data: 'Можно ли на гончарный круг и ручную лепку с детьми?'
        },
        {
            name: 'Где можно забрать работы после мк?',
            data: 'Где можно забрать работы после мк?'
        },
        {
            name: 'Что если вещь с мк треснула при обжиге?',
            data: 'Что если вещь с мк треснула при обжиге?'
        },
        {
            name: 'Можно ли мыть посуду в посудомойке?',
            data: 'Можно ли мыть посуду в посудомойке?'
        },
        {
            name: 'Можно ли ставить посуду в микроволновку?',
            data: 'Можно ли ставить посуду в микроволновку?'
        },
        {
            name: 'Себе можно забрать что слепишь?',
            data: 'Себе можно забрать что слепишь?'
        },
        {
            name: 'Какие умения нужны для МК?',
            data: 'Какие умения нужны для МК?'
        },
        {
            name: 'Из посуды можно потом есть?',
            data: 'Из посуды можно потом есть?'
        },
        {
            name: 'Теории глазурования учите?',
            data: 'Теории глазурования учите?'
        },
        {
            name: 'С атопическим дерматитом можно заниматься лепкой?',
            data: 'С атопическим дерматитом можно заниматься лепкой?'
        },
        {
            name: 'Я вымажусь на МК?',
            data: 'Я вымажусь на МК?'
        },
    ]
}

/**
 * Компонент блока "Календарь".
 * @extends react-redux
 * @memberof Home
 */
class Calendar extends Component {
    /**
     * @constructor
     * @param {Object} state                        данные компонента
     * @param {Object} state.calendar_data          локальное хранилище обновлённых данных календаря
     * @param {Object} state.fetch_data             локальное хранилище вызванных данных календаря
     * @param {Boolean} state.is_overflow           прокручивается ли блок (чтобы выводить правую границу)
     * @param {Boolean} state.is_drag               в данный момент прокручивается ли мышкой
     * @param {Boolean} state.gray_added            переменная для обозначения что граница справа добавлена
     * @param {Number} state.x_pos                  положение мышки
     * @param {Text} state.last_update              дата обновления календаря
     * @param {Boolean} state.empty_calendar        пустой ли календарь (для вывода сообщения)
     * @param {Object} props                        данные, пришедшие из store
     * @param {Object} props.data                   данные календаря с сервера
     * @param {Object} props.updatedCalendarData    обновлённые данные календаря
     * @param {Function} props.fetchData            запрос на сервер за данными календаря
     * @param {Function} props.updateData           обновление данных календаря
     */
    constructor(props) {
        super(props);

        this.state = {
            fetch_data: [],
            calendar_data: [],
            is_overflow: false,
            is_drag: false,
            is_faq_drag: false,
            gray_added: false,
            x_pos: null,
            last_update: null,
            empty_calendar: false
        };
        this._move_handler = this._move_handler.bind(this);
    }

    /**
     * Запрос на сервер за данными.
     */
    componentDidMount() {
        //функция обработки анимации блока с календарями
        // const _date_scroll = this._date_scroll;
        window.addEventListener('scroll', () => {
            requestAnimationFrame(this._date_scroll);
        });

        // if (this.props.updated_calendar_data === null) {
            fetch(this.props.url+'wp-json/wp/v2/mc-calendar').then((response) => {
                if(!response.ok) {
                    console.log("Что-то не так с календарём: " + response.statusText);
                }
                else return response;
            })
            .then((response) => response.json())
            .then((data) => {
                if (data.length > 0) {
                    this.setState({
                        fetch_data: data
                    })
                }
            })
        // }
    }

    /**
     * Обновление данных календаря (изменение его вида для лучшей работы).
     */
    componentDidUpdate() {
        if (this.state.fetch_data.length !== 0 && this.state.calendar_data.length === 0) {
            let temp_arr = [], updated_arr = [], last_update = null, is_empty = true;
            for (let i = 0; i < this.state.fetch_data.length; i++) {
                //видоизменяем данные с сервера, чтобы с ними было удобно работать
                let item = this.state.fetch_data[i];
                let temp_arr_item = {
                    name: '',
                    time: '',
                    price: '',
                    date: '',
                    day: '',
                    month: '',
                    year: '',
                    categories: [],
                    link: '',
                    image: '',
                    seats: ''
                }
                temp_arr_item.name = item.title.rendered;

                //обработка данных обновления
                let temp_var = this.state.fetch_data[i].modified.split('T');
                temp_var = temp_var[0].split('-');
                let temp_var_year = temp_var[0], temp_var_month = temp_var[1], temp_var_day = temp_var[2], temp_var_month_name = '', temp_var_date = new Date();
                let temp_var_today_year = temp_var_date.getFullYear(), temp_var_today_month = temp_var_date.getMonth()+1, temp_var_today_day = temp_var_date.getDate();

                //название месяца
                switch (+temp_var_month) {
                    case 1:
                        temp_var_month_name = 'января';
                        break;
                    case 2:
                        temp_var_month_name = 'февраля';
                        break;
                    case 3:
                        temp_var_month_name = 'марта';
                        break;
                    case 4:
                        temp_var_month_name = 'апреля';
                        break;
                    case 5:
                        temp_var_month_name = 'мая';
                        break;
                    case 6:
                        temp_var_month_name = 'июня';
                        break;
                    case 7:
                        temp_var_month_name = 'июля';
                        break;
                    case 8:
                        temp_var_month_name = 'августа';
                        break;
                    case 9:
                        temp_var_month_name = 'сентября';
                        break;
                    case 10:
                        temp_var_month_name = 'октября';
                        break;
                    case 11:
                        temp_var_month_name = 'ноября';
                        break;
                    case 12:
                        temp_var_month_name = 'декабря';
                        break;
                    default: 
                        break;
                }

                //блок с текстовым содержанием когда было обновлено
                let temp_last_update = "Обновлено " + temp_var_day + " " + temp_var_month_name;
                if (+temp_var_day === +temp_var_today_day && +temp_var_today_month === +temp_var_month) temp_last_update = "Обновлено сегодня"
                else if (+temp_var_month === +temp_var_today_month && +temp_var_today_day > 1 && +temp_var_day === +temp_var_today_day-1) temp_last_update = "Обновлено вчера"
                else if (+temp_var_month === +temp_var_today_month && +temp_var_today_day > 2 && +temp_var_day === +temp_var_today_day-2) temp_last_update = "Обновлено позавчера"

                //проверяем и обновляем данные
                if (last_update === null) {
                    last_update = Object.create(null);
                    last_update.item = temp_last_update;
                    last_update.day = temp_var_day;
                    last_update.month = temp_var_month;
                    last_update.year = temp_var_year;
                } else {
                    if (+temp_var_year === +last_update.year && +temp_var_month === +last_update.month && +temp_var_day > +last_update.day) {
                        last_update.item = temp_last_update;
                        last_update.day = temp_var_day;
                        last_update.month = temp_var_month;
                        last_update.year = temp_var_year;
                    } else if (+temp_var_year === +last_update.year && +temp_var_month > +last_update.month) {
                        last_update.item = temp_last_update;
                        last_update.day = temp_var_day;
                        last_update.month = temp_var_month;
                        last_update.year = temp_var_year;
                    } else if (+temp_var_year > +last_update.year) {
                        last_update.item = temp_last_update;
                        last_update.day = temp_var_day;
                        last_update.month = temp_var_month;
                        last_update.year = temp_var_year;
                    }
                }

                let price = item.content.rendered.split('class="calendar-price">');
                price = price[1];
                if (price !== undefined) {
                    price = price.split('</p>');
                    temp_arr_item.price = price[0];
                }

                let link = item.content.rendered.split('class="calendar-link">');
                link = link[1];
                if (link !== undefined) {
                    link = link.split('</p>');
                    temp_arr_item.link = link[0];
                }

                let image = item.content.rendered.split('calendar-image"><img ');
                image = image[1];
                if (image !== undefined) {
                    image = image.split(' />');
                    temp_arr_item.image = '<img style="pointer-events: none;" '+image[0]+' />';
                }
 
                //добавление категорий
                if (item.categories.length > 0) {
                    for (let l = 0; l < item.categories.length; l++) {
                        temp_arr_item.categories.push(item.categories[l]);
                    }
                }

                let date = item.content.rendered.split('class="calendar-date">'),
                    date_arr = [];
                date = date[1];
                if (date !== undefined) {
                    date = date.split('</p>');
                    date = date[0];
                    temp_arr_item.date = date;

                    let temp_new_arr = date.split('<br>');
                    //eslint-disable-next-line
                    temp_new_arr.forEach(item => {
                        let temp_new_arr_item = Object.create(null);
                        let date_split = item.split(', ');
                        let new_temp_arr = date_split[0].split('.');

                        let month_name = "";
                        switch (+new_temp_arr[1]) {
                            case 1:
                                month_name = 'января';
                                break;
                            case 2:
                                month_name = 'февраля';
                                break;
                            case 3:
                                month_name = 'марта';
                                break;
                            case 4:
                                month_name = 'апреля';
                                break;
                            case 5:
                                month_name = 'мая';
                                break;
                            case 6:
                                month_name = 'июня';
                                break;
                            case 7:
                                month_name = 'июля';
                                break;
                            case 8:
                                month_name = 'августа';
                                break;
                            case 9:
                                month_name = 'сентября';
                                break;
                            case 10:
                                month_name = 'октября';
                                break;
                            case 11:
                                month_name = 'ноября';
                                break;
                            case 12:
                                month_name = 'декабря';
                                break;
                            default: 
                                break;
                        }

                        //временная переменная, так как при простом объединении нельзя сразу перевести в число для проверки ниже
                        let temp_year = '20'+new_temp_arr[2];
                        
                        //проверка на дату (чтобы проверить выводятся хоть какие-нибудь элементы календаря и нужно ли выводить сообщение о пустом календаре)
                        if (is_empty === true && +temp_var_today_year === +temp_year && +temp_var_today_month === +new_temp_arr[1] && +temp_var_today_day <= +new_temp_arr[0]) is_empty = false
                        else if (is_empty === true && +temp_var_today_year === +temp_year && +temp_var_today_month < +new_temp_arr[1]) is_empty = false

                        temp_new_arr_item.name = temp_arr_item.name;
                        temp_new_arr_item.price = temp_arr_item.price;
                        temp_new_arr_item.date = date_split[0];
                        temp_new_arr_item.categories = temp_arr_item.categories;
                        temp_new_arr_item.link = temp_arr_item.link;
                        temp_new_arr_item.image = temp_arr_item.image;
                        temp_new_arr_item.day = new_temp_arr[0];
                        temp_new_arr_item.month = new_temp_arr[1];
                        temp_new_arr_item.year = new_temp_arr[2];
                        temp_new_arr_item.time = date_split[1];
                        if (date_split[2] !== undefined && date_split[2] === '&#8212;') temp_new_arr_item.seats = '-';
                        else temp_new_arr_item.seats = date_split[2];
                        if (temp_new_arr_item.time !== undefined && date_split[2] !== undefined && date_split[2] === '&#8212;') {
                            temp_new_arr_item.form_date = temp_new_arr_item.day+" "+month_name+", "+temp_new_arr_item.time+" (мест нет)"
                        } else if (temp_new_arr_item.time !== undefined) {
                            temp_new_arr_item.form_date = temp_new_arr_item.day+" "+month_name+", "+temp_new_arr_item.time
                        } else {
                            temp_new_arr_item.form_date = temp_new_arr_item.day+" "+month_name
                        }
                        date_arr.push(temp_new_arr_item);   //сюда отправляем чтобы потом корректно отображать данные
                        updated_arr.push(temp_new_arr_item);
                    })
                }

                //создаём новый массив для передачи в дочерний function компонент
                //сразу добавляем новый элемент в массив, если он пустой, если нет - начинаем проверку и добавляем дочерний элемент куда надо
                
                for (let l = 0; l < date_arr.length; l++) {
                    let item = date_arr[l];
                    if (item.year !== undefined && item.month !== undefined && item.day !== undefined) {
                        if (temp_arr.length === 0) {
                            let new_item = {
                                year:  item.year,
                                data: [{
                                    month: item.month,
                                    data: [{
                                        day: item.day,
                                        data: [
                                            item
                                        ]
                                    }]
                                }]
                            }
                            temp_arr.push(new_item);
                        } else {
                            let year_id = null;
                            for (let l = 0; l < temp_arr.length; l++) {
                                if (+temp_arr[l].year === +item.year) {
                                    year_id = l;
                                }
                            }
                            if (year_id !== null) {
                                let month_id = null;
                                for (let k = 0; k < temp_arr[year_id].data.length; k++) {
                                    if (+temp_arr[year_id].data[k].month === +item.month) {
                                        month_id = k;
                                    }
                                }
                                if (month_id !== null) {
                                    let day_id = null;
                                    for (let j = 0; j < temp_arr[year_id].data[month_id].data.length; j++) {
                                        if (+temp_arr[year_id].data[month_id].data[j].day === +item.day) {
                                            day_id = j;
                                        }
                                    }
                                    //добавляем в массив
                                    if (day_id !== null) {
                                        let new_item = item;
                                        temp_arr[year_id].data[month_id].data[day_id].data.push(new_item);
                                        temp_arr[year_id].data[month_id].data[day_id].data = temp_arr[year_id].data[month_id].data[day_id].data.sort(compareDate);
                                    } else {
                                        let new_item = {
                                            day: item.day,
                                            data: [
                                                item
                                            ]
                                        }
                                        temp_arr[year_id].data[month_id].data.push(new_item);
                                        temp_arr[year_id].data[month_id].data = temp_arr[year_id].data[month_id].data.sort(compareDate);
                                    }
                                } else {
                                    let new_item = {
                                        month: item.month,
                                        data: [{
                                            day: item.day,
                                            data: [
                                                item
                                            ]
                                        }]
                                    }
                                    temp_arr[year_id].data.push(new_item);
                                    temp_arr[year_id].data = temp_arr[year_id].data.sort(compareDate);
                                }
                            } else {
                                let new_item = {
                                    year:  item.year,
                                    data: [{
                                        month: item.month,
                                        data: [{
                                            day: item.day,
                                            data: [
                                                item
                                            ]
                                        }]
                                    }]
                                }
                                temp_arr.push(new_item);
                                temp_arr = temp_arr.sort(compareDate);
                            }
                        }
                    }
                }
            }
            this.props.update_calendar_data(updated_arr);
            this.setState({
                empty_calendar: is_empty,
                calendar_data: temp_arr,
                last_update: last_update.item
            })
        }

        //проверка по количеству элементов, чтобы показывать правую границу при прокрутке
        let articles = document.getElementsByClassName('article-block__container');
        if (articles !== undefined && articles !== null && articles.length > 0 && this.state.is_overflow === false) {
            for (let i = 0; i < articles.length; i++) {
                let counter = 0;
                for (let l = 0; l < articles[i].children.length; l++) {
                    if (!articles[i].children[l].attributes.class.nodeValue.includes('article-block_disabled')) counter += 1;
                    if (counter > 4) break;
                }
                if (counter > 4) {
                    this.setState({
                        is_overflow: true
                    })
                    break;
                }
            }
        }

        //обновляем значение с небольшой задержкой, чтобы ссылка не открывалась после того как отпускаешь кнопку
        if (this.state.is_drag === false && this.state.is_faq_drag === true) {
            setTimeout(() => {
                this.setState({
                    is_faq_drag: false
                })
            }, 100)
        }

        //добавление серых блоков в пустое место
        let article_list = document.getElementsByClassName('article-block');
        if (article_list !== undefined && article_list !== null && article_list.length > 0 && this.state.gray_added === false) {
            let max_items_counter = 0, temp_arr = document.getElementsByClassName('article-block__list'), article_list_length = 0;

            for (let i = 0; i < temp_arr.length; i++) {
                //проверка идёт на кол-во элементов и на то, являются ли эти элементы активными
                if (!temp_arr[i].parentElement.attributes.class.nodeValue.includes('article-block_disabled')) {
                    article_list_length += 1;
                    if (temp_arr[i].children.length > max_items_counter) {
                        max_items_counter = temp_arr[i].children.length;
                    }
                }
            }

            //функция для выбора случайного числа от нуля до заданного `max`
            function getRandomInt(max) {
                return Math.floor(Math.random() * Math.floor(max));
            }

            for (let i = 0; i < temp_arr.length; i++) {
                //проверка идёт на кол-во элементов и на то, являются ли эти элементы активными
                if (!temp_arr[i].parentElement.attributes.class.nodeValue.includes('article-block_disabled')) {
                    //добавляем серые блоки, если есть пустое пространство
                    if (temp_arr[i].children.length < max_items_counter) {
                        let children_length = temp_arr[i].children.length;
                        let need_counter = max_items_counter - children_length;

                        let link_pos_counter = getRandomInt(need_counter);

                        for (let l = 0; l < need_counter; l++) {
                            if (l === link_pos_counter) {
                                //выбираем позицию случайного вопроса
                                let faq_pos_counter = getRandomInt(data.faq_headers.length);

                                //собираем элемент
                                let article_item = document.createElement('article');
                                article_item.className = "calendar-item__block calendar-item__block-fadeIn d-m-none";
    
                                let gray_container = document.createElement('div');
                                gray_container.className = "calendar-item__container calendar-item__container_empty-block";
    
                                //вешаем и приписываем все необходимые данные
                                let gray_block = document.createElement('a');
                                gray_block.className = "calendar-item__link calendar-item__link_faq";
                                gray_block.href = "/faq";
                                gray_block.hash = data.faq_headers[faq_pos_counter].data;
                                gray_block.target = '_blank';
                                gray_block.text = data.faq_headers[faq_pos_counter].name;
                                gray_block.draggable = 'true';
                                gray_block.onclick = (e) => {
                                    if (this.state.is_faq_drag === true) {
                                        e.preventDefault();
                                    }
                                }
                                gray_block.ondragstart = (e) => {
                                    this.setState({
                                        is_faq_drag: true
                                    })
                                    e.stopPropagation();
                                    e.preventDefault();
                                }
    
                                gray_container.appendChild(gray_block);
                                article_item.appendChild(gray_container);
    
                                //добавляем значение в DOM
                                temp_arr[i].appendChild(article_item);

                            } else {
                                //собираем элемент
                                let article_item = document.createElement('article');
                                article_item.className = "calendar-item__block calendar-item__block-fadeIn d-m-none";

                                let gray_container = document.createElement('div');
                                gray_container.className = "calendar-item__container calendar-item__container_empty-block";

                                let gray_block = document.createElement('div');
                                gray_block.className = "calendar-item__link";

                                gray_container.appendChild(gray_block);
                                article_item.appendChild(gray_container);

                                //добавляем значение в DOM
                                temp_arr[i].appendChild(article_item);
                            }
                        }
                    }
                }
            }

            //проверка на то, меньше 4 элементов или нет
            if (article_list_length < 4) {
                // собираем новые элементы для добавления
                let new_item = document.createElement('li');
                new_item.className = 'article-block d-m-none';

                let new_item_header = document.createElement('h4');
                new_item_header.className = "article-block__header";
                new_item_header.innerText = 'Скоро';
                new_item.appendChild(new_item_header);

                let column = document.createElement('div');
                column.className = "article-block__list";
                for (let l = 0; l < max_items_counter; l++) {
                    let article_item = document.createElement('article');
                    article_item.className = "calendar-item__block calendar-item__block-fadeIn";

                    let gray_container = document.createElement('div');
                    gray_container.className = "calendar-item__container calendar-item__container_empty-block";

                    let gray_block = document.createElement('div');
                    gray_block.className = "calendar-item__link";

                    gray_container.appendChild(gray_block);
                    article_item.appendChild(gray_container);
                    column.appendChild(article_item);
                }

                //собираем элементы
                new_item.appendChild(column);

                //сколько нужно установить "столбиков" с серыми блоками
                let needed_count = 4 - article_list_length;

                let container = document.getElementsByClassName('article-block__container')[0];
                //добавляем нужное колличество в страницу
                for (let l = 0; l < needed_count; l++) {
                    container.appendChild(new_item);
                }
            }

            //отправляем значение, что значения на странице
            this.setState({
                gray_added: true
            })
        }
    }

    //обработчик захвата мышки для прокрутки блока
    _move_handler(e) {
        let container = document.getElementsByClassName('calendar-list__container')[0];
        let left_border = document.getElementsByClassName('calendar-list__container-left-border')[0],
            right_border = document.getElementsByClassName('calendar-list__container-right-border')[0];
        
        //высчитываем для хрома значения
        let maxScrollLeft = container.scrollWidth - container.clientWidth;
        if (this.state.is_drag === true) {
            container.attributes.class.nodeValue = 'calendar-list__container calendar-list__container_dragging';
            //если пользователь перемещает мышь влево относительно места клика, то прокручиваем вправо

            if (e.clientX < this.state.x_pos) {
                if (container.scrollLeft < maxScrollLeft) {
                    container.scrollLeft += this.state.x_pos - e.clientX;
                }
                //отправляем данные каждый раз для правильного счёта
                this.setState({
                    x_pos: e.clientX
                })
            //аналогично пункту выше, только прокручиваем влево
            } else if (e.clientX > this.state.x_pos) {
                if (container.scrollLeft > 0) {
                    container.scrollLeft -= e.clientX - this.state.x_pos;
                }
                //отправляем данные каждый раз для правильного счёта
                this.setState({
                    x_pos: e.clientX
                })
            }
        } else {
            container.attributes.class.nodeValue = 'calendar-list__container';
        }
        
        if (container.scrollLeft > 0) {
            left_border.attributes.class.nodeValue = 'calendar-list__container-left-border'
        } else if (container.scrollLeft === 0) {
            left_border.attributes.class.nodeValue = 'calendar-list__container-left-border calendar-list__container-left-border_none'
        }
        if (container.scrollLeft === maxScrollLeft) {
            right_border.attributes.class.nodeValue = 'calendar-list__container-right-border calendar-list__container-right-border_none'
        } else if (container.scrollLeft < maxScrollLeft) {
            right_border.attributes.class.nodeValue = 'calendar-list__container-right-border'
        }
    }

    //функция прокрутки даты
    _date_scroll() {
        let calendar_list = document.getElementsByClassName('calendar')[0];
        if (calendar_list !== undefined) {
            let box = calendar_list.getBoundingClientRect();
            let top_pos = -box.top-40;
            let header = document.getElementsByClassName('article-block__header');
            if (header !== undefined && header.length > 0) {
                for (let i = 0; i < header.length; i++) {
                    if (top_pos > 0 && top_pos < calendar_list.clientHeight-100) header[i].style.top = top_pos+"px";
                    else if (top_pos <= 0 && header[i].style.top !== '0px') header[i].style.top = "0px";
                }
            }
        }
    }

    /**
     * Сверка данных с текущей датой, чтобы не выводить "старые" записи, а также слова вместо цифр в месяце.
     */
    render() {
        let date = new Date();
        let day = date.getDate();
        let month = date.getMonth()+1;
        let year = date.getFullYear();
        if (this.state.calendar_data.length > 0) {
            return(
                <section className="calendar" id="shedule-dist">
                    <h2 className="calendar-header"><span className="calendar-header_container">Расписание мастер-классов</span>{this.state.last_update !== null ? <span className="calendar-header calendar-header_last-update">{this.state.last_update}</span> : null}</h2>
                    {/* <ul className="calendar-sort"></ul> */}
                    {
                        this.state.empty_calendar === false ?
                        <ul className={this.state.is_overflow === true ? "calendar-list" : "calendar-list calendar-list_not-overflow"}>
                            <div className="calendar-list__container-left-border calendar-list__container-left-border_none" />
                            {
                                this.state.calendar_data.length === 0 ?
                                null :
                                this.state.calendar_data.map((item1, index) => {
                                    let article_year = "20"+item1.year;
                                    return(
                                        //eslint-disable-next-line
                                        <div key={index} className="calendar-list__container"
                                        onMouseDown={(e) => this.setState({ is_drag: true, x_pos: e.clientX })}
                                        onMouseUp={() => this.setState({ is_drag: false })}
                                        onMouseMove={(e) => this._move_handler(e)}
                                        onMouseLeave={() => this.setState({ is_drag: false, x_pos: 0 })}
                                        onWheel={(e) => this._move_handler(e)}
                                        >
                                            {
                                                item1.data.length === 0 ?
                                                null :
                                                item1.data.map((item2, index) => {
                                                    let month_name = ''; //имя месяца (текстовое)
                                                    let display = true; //показывать ли блок (если меньше нынешней даты - не показывать)
                                                    switch (+item2.month) {
                                                        case 1:
                                                            month_name = 'января';
                                                            break;
                                                        case 2:
                                                            month_name = 'февраля';
                                                            break;
                                                        case 3:
                                                            month_name = 'марта';
                                                            break;
                                                        case 4:
                                                            month_name = 'апреля';
                                                            break;
                                                        case 5:
                                                            month_name = 'мая';
                                                            break;
                                                        case 6:
                                                            month_name = 'июня';
                                                            break;
                                                        case 7:
                                                            month_name = 'июля';
                                                            break;
                                                        case 8:
                                                            month_name = 'августа';
                                                            break;
                                                        case 9:
                                                            month_name = 'сентября';
                                                            break;
                                                        case 10:
                                                            month_name = 'октября';
                                                            break;
                                                        case 11:
                                                            month_name = 'ноября';
                                                            break;
                                                        case 12:
                                                            month_name = 'декабря';
                                                            break;
                                                        default: 
                                                            break;
                                                    }
                                                    let display_count = null,
                                                        temp_children_arr = item2.data;
                                                    if (+month === +item2.month) {
                                                        temp_children_arr = temp_children_arr.filter(temp_item => {
                                                            return +temp_item.day >= +day;
                                                        })
                                                        if (temp_children_arr.length < 4) display_count = temp_children_arr.length;
                                                    } else if ((+month > +item2.month && +article_year === +year) || +article_year < +year) display_count = 0;
                                                    return(
                                                        <div key={index} className={display_count === null ?
                                                                                    "article-block__container" :
                                                                                    "article-block__container article-block__container_"+display_count*25}>
                                                            {
                                                                item2.data.length === 0 ?
                                                                null :
                                                                item2.data.map((item3, index) => {
                                                                    let header = '';
                                                                    if (+month === +item2.month && +day === +item3.day) header = 'Сегодня';
                                                                    else header = +item3.day+" "+month_name;
                                                                    if (+article_year === +year) {
                                                                        if (+month > +item2.month) display = false
                                                                        else if (+month === +item2.month && +day > +item3.day) display = false
                                                                        else display = true
                                                                    } else if (+article_year > +year) display = false
                                                                    else if (+article_year < +year) display = false
                                                                    else display = true;
                                                                    return(
                                                                        <li className={display ? "article-block" : "article-block article-block_disabled"} key={index}>
                                                                            <h4 className="article-block__header">{header}</h4>
                                                                            {
                                                                                item3.data.length === 0 ?
                                                                                null :
                                                                                <div className="article-block__list">
                                                                                    {
                                                                                        item3.data.map((item4, index) => {
                                                                                            return(
                                                                                                <CalendarItem key={index} data={item4} is_drag={this.state.is_drag} />
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            }
                                                                        </li>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    )
                                })
                            }
                            <div className={this.state.is_overflow === true ? "calendar-list__container-right-border" : "calendar-list__container-right-border calendar-list__container-right-border_none"} />
                        </ul>   :
                        <div className="calendar-empty">
                            <div className="d-m-none">
                                <p>
                                    В расписании пока нет мастер-классов.<br/>
                                    Позвоните нам, чтобы узнать детали:<br/>
                                    +375 33 673-85-60<br/>
                                    +375 29 123-8-654
                                </p>
                            </div>
                            <div className="d-c-none">
                                <p>
                                    В расписании пока нет мастер-классов.<br/>
                                    Позвоните нам, чтобы узнать детали:
                                </p>
                                <a className="calendar-empty__phone" href="tel:+375336738560">+375 33 673-85-60</a>
                                <br/>
                                <a className="calendar-empty__phone" href="tel:+375292378654">+375 29 123-8-654</a>
                            </div>
                        </div>
                    }
                </section>
            )
        } else {
            return(
                <section />
            )
        }
    }
};

const mapStateToProps = (state) => {
    return {
        url: state.site_options.SITE_URL,
        updated_calendar_data: state.updated_calendar_data
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        update_calendar_data: (data) => dispatch(update_calendar_data(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);
